import UserInfosStep from '@/components/onboarding-v2/steps/UserInfosStep.vue';
import ConnectStep from '@/components/onboarding-v2/steps/ConnectStep.vue';
import ShopConfirmStep from '@/components/onboarding-v2/steps/ShopConfirmStep.vue';
import LiftOffStep from '@/components/onboarding-v2/steps/LiftOffStep.vue';

const OnboardingV2Components = {
  UserInfosStep,
  ConnectStep,
  ShopConfirmStep,
  LiftOffStep,
};

export default OnboardingV2Components;
